import { useLearnerAuth } from "../providers/LearnerAuthProvider";

export function useIsLearnerLogin(): boolean {
  const { learnerAuth } = useLearnerAuth();
  return !!learnerAuth?.isLearnerLogin;
}
